import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIResponse } from '../interfaces/api.interface';
import {
  OrganisationSuite,
  OrganisationSuiteCreate,
  OrganisationSuiteUpdate,
} from '../interfaces/organisation-suite.interface';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class OrganisationSuiteService {
  public constructor(private readonly api: ApiService) {}

  public getAll(organisationId: string): Observable<APIResponse<OrganisationSuite[]>> {
    return this.api.get(`admin/organisations/${organisationId}/suites`);
  }

  public getOne(organisationId: string, code: string): Observable<OrganisationSuite> {
    return this.api.get(`admin/organisations/${organisationId}/suites/${code}`);
  }

  public create(organisationId: string, payload: OrganisationSuiteCreate): Observable<OrganisationSuite> {
    return this.api.post(`admin/organisations/${organisationId}/suites`, payload);
  }

  public update(organisationId: string, code: string, payload: OrganisationSuiteUpdate): Observable<OrganisationSuite> {
    return this.api.put(`admin/organisations/${organisationId}/suites/${code}`, payload);
  }
}
